import React from "react";

import styles from "./style.module.css";

import { NumberLabel, getPrettyNumber } from "aible";

const DATA_EVAL = {
  CLOSED_WON: [],
  CLOSED_LOST: [],
  IN_PROGRESS: [],
  NO_CHANGE: []
};

import { BarChart, ResponsiveContainer, Bar, XAxis, YAxis, CartesianGrid, Tooltip } from "recharts";

const DATA_EVAL_COLORS = {
  "Closed Won": "#56CCF2",
  "Closed Lost": "#BB6BD9",
  "In Progress": "#1A6FE1",
  "No Change": "#E6E6FC"
};

export default class DataEvaluation extends React.PureComponent {
  render() {
    const { monitoringData } = this.props;

    let retTotals = {
      "Closed Won": 0,
      "Closed Lost": 0,
      "In Progress": 0,
      "No Change": 0
    };

    const retMonitoringData = monitoringData.map((elem, i) => {
      const currCW = parseInt(elem.count * DATA_EVAL.CLOSED_WON[i]) + retTotals["Closed Won"];
      const currCL = parseInt(elem.count * DATA_EVAL.CLOSED_LOST[i]) + retTotals["Closed Lost"];
      const currIP = parseInt(elem.count * DATA_EVAL.IN_PROGRESS[i]) + retTotals["In Progress"];
      const currNC = parseInt(elem.count * DATA_EVAL.NO_CHANGE[i]) + retTotals["No Change"];
      retTotals["Closed Won"] = currCW;
      retTotals["Closed Lost"] = currCL;
      retTotals["In Progress"] = currIP;
      retTotals["No Change"] = currNC;
      return {
        "Closed Won": currCW,
        "Closed Lost": currCL,
        "In Progress": currIP,
        "No Change": currNC,
        Date: elem.date
      };
    });

    return (
      <div className={styles.userFeedbackWrapper}>
        <div className={styles.userFeedbackTitle} style={{ paddingLeft: "15px" }}>
          {"Total Leads Evaluated"}
        </div>
        <div className={styles.userFeedbackLegend + " " + styles.dataEvaluationLegendWrapper}>
          <LegendItem color={DATA_EVAL_COLORS["Closed Won"]} label={"Closed Won"} value={retTotals["Closed Won"]} />
          <LegendItem color={DATA_EVAL_COLORS["Closed Lost"]} label={"Closed Lost"} value={retTotals["Closed Lost"]} />
          <LegendItem color={DATA_EVAL_COLORS["In Progress"]} label={"In Progress"} value={retTotals["In Progress"]} />
          <LegendItem color={DATA_EVAL_COLORS["No Change"]} label={"No Change"} value={retTotals["No Change"]} />
        </div>
        <div className={styles.dataEvaluationBody}>
          <BarGraph data={retMonitoringData} />
        </div>
      </div>
    );
  }
}

class LegendItem extends React.PureComponent {
  render() {
    const { color, label, value } = this.props;
    return (
      <div className={styles.dataEvaluationLegend}>
        <div className={styles.dataEvaluationLegendTitle + " " + styles.dataEvaluationLegendTitle}>
          <NumberLabel>{value}</NumberLabel>
        </div>
        <div className={styles.userFeedbackLegendItem + " " + styles.dataEvaluationLegendItem}>
          <div className={styles.userFeedbackLegendIndicator} style={{ background: color }} />
          <div className={styles.userFeedbackLegendLabel + " " + styles.dataEvaluationLegendLabel}>{label}</div>
        </div>
      </div>
    );
  }
}

class BarGraph extends React.PureComponent {
  render() {
    const { data } = this.props;

    if (!data) {
      return <div />;
    }

    return (
      <ResponsiveContainer height={400}>
        <BarChart
          width={500}
          height={300}
          data={data}
          margin={{
            top: 0,
            right: 30,
            left: 20,
            bottom: 5
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="Date" />
          <YAxis tickFormatter={(tick) => getPrettyNumber(tick)} />
          <Tooltip />
          <Bar dataKey="No Change" stackId="a" fill={DATA_EVAL_COLORS["No Change"]} />
          <Bar dataKey="In Progress" stackId="a" fill={DATA_EVAL_COLORS["In Progress"]} />
          <Bar dataKey="Closed Lost" stackId="a" fill={DATA_EVAL_COLORS["Closed Lost"]} />
          <Bar dataKey="Closed Won" stackId="a" fill={DATA_EVAL_COLORS["Closed Won"]} />
        </BarChart>
      </ResponsiveContainer>
    );
  }
}
